import React, { FC } from 'react'
import { Box, Flex, Heading } from '@moonpig/launchpad-components'
import { styled, breakpoint } from '@moonpig/launchpad-utils'

const BREAKPOINT = 'md'

const StyledGalleryHeader = styled(Flex)`
  flex-direction: column;
  line-height: 1;

  ${breakpoint(BREAKPOINT)} {
    align-items: center;
    flex-direction: row;
    line-height: 0.8;
  }
`

type Props = {
  title: string
}

export const Header: FC<Props> = ({ title }) => {
  return (
    <StyledGalleryHeader>
      {
        <Box mr={3} mb={6}>
          <Heading
            display="inline"
            level="h1"
            typography={{
              xs: 'typeMobileDisplay03',
              md: 'typeDesktopDisplay03',
            }}
          >
            {title}
          </Heading>
        </Box>
      }
    </StyledGalleryHeader>
  )
}
